import { useState } from "react";
import { Button } from "./ui/button";

type TermsOfUseProps = {
  onAccept: () => void;
};
export default function TermsOfUse({ onAccept }: TermsOfUseProps) {
  const [termsAccepted, setTermsAccepted] = useState(false);

  return (
    <div className="p-20 border flex flex-col text-secondary h-[100vh]">
      <h1 className="text-3xl font-bold">Termos de Uso de Dados Pessoais</h1>
      <div className="rounded border p-5 flex-1 overflow-y-auto my-8 max-h-[40vh]">
        <p>
          <strong>1. Introdu&ccedil;&atilde;o</strong>
        </p>
        <div>
          Este Termo de Uso de Dados Pessoais tem como objetivo informar como
          tratamos e protegemos o seu CPF, em conformidade com a Lei Geral de
          Prote&ccedil;&atilde;o de Dados Pessoais (Lei 13.709/2018 - LGPD). Ao
          fornecer seu CPF para participar do nosso quiz, voc&ecirc; concorda
          com a coleta, uso e tratamento desse dado conforme descrito abaixo.
          <br />
          <strong>
            <br />
          </strong>
        </div>
        <div>
          <strong>2. Coleta do CPF</strong>
        </div>
        <div>
          Coletamos o CPF para garantir a identifica&ccedil;&atilde;o
          &uacute;nica do participante no quiz, evitando m&uacute;ltiplos
          acessos ou participa&ccedil;&otilde;es indevidas e assegurando a
          integridade dos resultados.
        </div>
        <div>
          <br />
          <strong>3. Finalidade do Tratamento do CPF</strong>
        </div>
        <div>
          O CPF ser&aacute; utilizado exclusivamente para:
          <br />
          <br />
        </div>
        <div>
          <ul>
            <li>Identificar o participante de maneira &uacute;nica no quiz</li>
            <li>Garantir um acesso por pessoa</li>
            <li>
              Gerenciar eventuais premia&ccedil;&otilde;es associadas ao quiz
            </li>
            <li>
              Cumprir obriga&ccedil;&otilde;es legais, se necess&aacute;rio
            </li>
          </ul>
        </div>
        <br />
        <div>
          <strong>4. Compartilhamento de Dados Pessoais</strong>
        </div>
        <div>
          Seu CPF ser&aacute; tratado de forma confidencial e n&atilde;o
          ser&aacute; compartilhado com terceiros, exceto com prestadores de
          servi&ccedil;os estritamente necess&aacute;rios para o funcionamento
          do quiz, sempre em conformidade com a LGPD, ou em casos exigidos por
          lei.
          <br />
          <br />
        </div>
        <div>
          <strong>5. Armazenamento e Seguran&ccedil;a dos Dados</strong>
        </div>
        <div>
          Seu CPF ser&aacute; armazenado em ambientes seguros, com a
          utiliza&ccedil;&atilde;o de medidas de seguran&ccedil;a adequadas para
          proteger seus dados contra acesso n&atilde;o autorizado, uso indevido,
          perda ou destrui&ccedil;&atilde;o. Mantemos pol&iacute;ticas rigorosas
          de seguran&ccedil;a da informa&ccedil;&atilde;o para garantir a
          prote&ccedil;&atilde;o de seus dados.
        </div>
        <div>
          <br />
          <strong>6. Reten&ccedil;&atilde;o de Dados</strong>
        </div>
        <div>
          O CPF ser&aacute; mantido apenas pelo tempo necess&aacute;rio para as
          finalidades mencionadas acima. Ap&oacute;s esse per&iacute;odo,
          ser&aacute; eliminado de forma segura, exceto quando houver
          obriga&ccedil;&atilde;o legal de mant&ecirc;-lo.
        </div>
        <div>
          <br />
          <strong>7. Direitos dos Titulares de Dados</strong>
        </div>
        <div>
          De acordo com a LGPD, voc&ecirc; tem o direito de:
          <br />
          Acessar seus dados pessoais (inclusive o CPF)
          <br />
          Solicitar a corre&ccedil;&atilde;o de dados incorretos
          <br />
          Pedir a exclus&atilde;o de seus dados (CPF) ao t&eacute;rmino de sua
          utiliza&ccedil;&atilde;o
          <br />
          Revogar o consentimento a qualquer momento
        </div>
        <div>
          <br />
          <strong>8. Atualiza&ccedil;&otilde;es deste Termo</strong>
        </div>
        <div>
          Este Termo poder&aacute; ser atualizado periodicamente para refletir
          eventuais mudan&ccedil;as no tratamento dos dados. Quaisquer
          altera&ccedil;&otilde;es ser&atilde;o comunicadas atrav&eacute;s dos
          nossos canais de comunica&ccedil;&atilde;o.
        </div>
        <div>
          <br />
          <strong>9. Contato</strong>
        </div>
        <div>
          Se voc&ecirc; tiver d&uacute;vidas ou quiser exercer seus direitos
          relacionados &agrave; prote&ccedil;&atilde;o de dados, entre em
          contato conosco atrav&eacute;s do e-mail [seu-email@empresa.com].
        </div>
        <div>
          <br />
          <strong>10. Consentimento</strong>
        </div>
        <div>
          Ao fornecer seu CPF, voc&ecirc; declara que leu e concorda com este
          Termo de Uso de Dados Pessoais, estando ciente das finalidades
          espec&iacute;ficas para o uso desse dado no quiz.
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="space-x-2">
          <input
            id="accept"
            name="accept"
            type="checkbox"
            onChange={(e: any) => {
              setTermsAccepted(e.nativeEvent.target.checked);
            }}
          />
          <label htmlFor="accept">
            Li e concordo com os termos apresentados
          </label>
        </div>
        <Button
          disabled={!termsAccepted}
          onClick={onAccept}
          className="text-lg p-6 uppercase"
        >
          ENVIAR TERMO
        </Button>
      </div>
    </div>
  );
}
